import React, { useEffect, useState } from "react";
import STLViewer from "../Canvas/STLViewer";
import axios from "axios";
import config from '../../config';
import { headers } from '../../token';
import ColorBox from '../ColorBox';
import STLViewerQuot from "../Canvas/STLViewerQuot";

const ViewsBussinessFile = ({ CloseViewFiles, urlFile, Filename }) => {

   
    const getFileExtension = (url) => {
        const parts = url.split('.');
        return parts.length > 1 ? parts.pop().toLowerCase() : '';
    };

    const fileExtension = getFileExtension(urlFile);
    const isSTL = fileExtension === 'stl' || fileExtension === 'obj';
    
    const [currentColor, setCurrentColor] = useState("0x808080");
    const [materialList, setMaterialList] = useState([]);
    const [selectedMaterialColor, setSelectedMaterialColor] = useState('#FFFFFF');

    const server_backend = config.API_URL;

    useEffect(() => {
        const getMaterial = async () => {
            try {
                const response = await axios.get(`${server_backend}/materials/list`, headers);
                //console.log(response.data);
                if (response.data.RES_CODE === "00") {
                    setMaterialList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error);
            }
        };

        getMaterial();
    }, []);


    return (
        <div>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        {isSTL ? Filename :
                            <span style={{ color: 'red' }}>
                                The file has not been loaded correctly. Please ensure it is the correct file type. If the issue persists, please re-upload the file.
                            </span>
                        }
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><a href="javascript: void(0);">Files</a></li>
                                <li className="breadcrumb-item active">STL</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="card p-5">

                    <div className="col-12">
                        <div className=" d-sm-flex align-items-center justify-content-between" style={{ marginTop: "-1px" }}>
                            <button className='btn btn-warning' onClick={CloseViewFiles}>Go Back</button>

                        </div>
                    </div>
                    <div>
                        <div className="row">
                            <div className="col-6">
                                <center>{isSTL ? (<h6>{Filename}</h6>) :
                                    <span style={{ color: 'red' }}>
                                        The file has not been loaded correctly. Please ensure it is the correct file type. If the issue persists, please re-upload the file.
                                    </span>
                                }</center>
                                <div>
                                    {isSTL ? <STLViewerQuot url={urlFile} currentColor={selectedMaterialColor} mystl={true} /> : null}
                                </div>
                            </div>
                            <div className="col-6">
                                <div>
                                    <center>
                                        <h6>Materials</h6>
                                    </center>
                                    <div className="show" style={{
                                        maxHeight: '53vh',
                                        height: '53vh',
                                        border: '1px solid #dcdcdc',
                                        padding: "20px",
                                        width: "96%",
                                        backgroundColor: "#fff",
                                        overflowY: 'auto'
                                    }}>
                                        {materialList && materialList.length > 0 ? (
                                            materialList.map((material) => (
                                                <button
                                                    key={material.mat_ID}
                                                    className={`dropdown-item d-flex align-items-center justify-content-between`}
                                                    type="button"
                                                    onClick={() => {
                                                        setSelectedMaterialColor(material.color);
                                                    }}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <ColorBox color={material.color} />
                                                        <span className="ms-2">{material.name}</span>
                                                    </div>
                                                </button>
                                            ))
                                        ) : (
                                            <button className="dropdown-item" type="button" disabled>
                                                No materials found
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewsBussinessFile;
